import React from "react";
import { Tab, withStyles } from "@material-ui/core";

export const StyledTab = withStyles((theme) => ({
    root: {
        height: 50,
        minHeight: "auto",
        minWidth: "50%",
        borderBottom: '4px solid #D3D3D3',
        [theme.breakpoints.down('md')]: {
            minWidth: "45%",
        },
        [theme.breakpoints.down('sm')]: {
            minWidth: "50%",
        },
    },
    selected: {
        color: '#304D6E',
        backgroundColor: '#F0F3F4',
        borderBottom: '4px solid #00000000',
    },
}))(Tab);
